import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./SupervisorWasteLog.module.css";
import { useNavigate } from "react-router-dom";
import { Dropdown, InputField, SearchInput, TextComponent, Modal } from "../../../../components";
import { SubmitButton } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import ModalLeft from "../../../../components/ModalLeft/ModalLeft";
import { ReactComponent as MinusIcon } from "../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/plusIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";


const reasonOpt = [
    {
        value: "Reason",
        role: "Reason",
        id: 1,
    },
    {
        value: "Burnt",
        role: "Burnt",
        id: 2,
    },
    {
        value: "Expired",
        role: "Expired",
        id: 3,
    },
    {
        value: "Spoilt",
        role: "Spoilt",
        id: 4,
    },
    {
        value: "Donated",
        role: "Donated",
        id: 5,
    }
]

const WasteLog = () => {
    const navigate = useNavigate();

    const [addModal, setaddModal] = useState(false);
    const [editModal, setEditModal] = useState(false)
    const [quantity, setquantity] = useState(2);
    const [name, setname] = useState('');
    const [reason, setreason] = useState('');
    const [category, setcategory] = useState('');
    const [isModal, setIsModal] = useState(true);
    const [password, setPassword] = useState("")
    const [deleteModal, setDeleteModal] = useState(false)
    const [itemName, setItemName] = useState("")
    const [lotNo, setLotNo] = useState("")
    const [taskId, setTaskId] = useState("")
    const [filterModal, setFilterModal] = useState(false);
    const [reasonFilter, setReasonFilter] = useState({
        value: "Reason",
        role: "Reason",
        id: 1,
    });

    const categories = [
        {
            value: "Ingredient",
            role: "Ingredient",
            id: 1,
        },
        {
            value: "Component",
            role: "Component",
            id: 2,
        },
        {
            value: "Material",
            role: "Material",
            id: 3,
        },

    ];

    const reasons = [
        {
            value: "Burnt",
            role: "Burnt",
            id: 1,
        },
        {
            value: "Expired",
            role: "Expired",
            id: 2,
        },
        {
            value: "Spoilt",
            role: "Spoilt",
            id: 3,
        },
        {
            value: "Donated",
            role: "Donated",
            id: 4,
        }
    ];
    const columns = [
        {
            title: "Task ID",
            dataIndex: "TaskID",
            key: "TaskID",
        },
        {
            title: "Item Name",
            dataIndex: "ItemName",
            key: "ItemName",
        },
        {
            title: "Lot No",
            dataIndex: "LotNo",
            key: "LotNo",
        },
        {
            title: "Quantity",
            key: "Quantity",
            dataIndex: "Quantity",
        },
        {
            title: "Waste",
            key: "Waste",
            dataIndex: "Waste",
        },
        {
            title: "Recorded",
            key: "Recorded",
            dataIndex: "Recorded",
        },

        {
            title: "Actions",
            key: "Actions",
            dataIndex: "Actions",
            render: (text, record) => record.Actions,
        },

    ];

    const data = [
        {
            TaskID: "#001",
            ItemName: "Croissant",
            LotNo: "#123",
            Quantity: "12 pcs",
            Waste: "Burnt during baking",
            Recorded: "John Doe",
            Actions: [
                <div className={styles.itemsButtonDiv}>
                    <DeleteIcon
                        className={styles.itemsButton}
                        onClick={() => setDeleteModal(true)}
                    />
                    <EditIcon
                        className={styles.itemsButton}
                        onClick={() => setEditModal(true)}
                    />
                </div>,
            ],
        },
        {
            TaskID: "#002",
            ItemName: "Chocolate ",
            Quantity: "1 whole",
            LotNo: "#123",
            Waste: "Expired",
            Recorded: "Sarah Khan",
            Actions: [
                <div className={styles.itemsButtonDiv}>
                    <DeleteIcon
                        className={styles.itemsButton}
                        onClick={() => setDeleteModal(true)}
                    />
                    <EditIcon
                        className={styles.itemsButton}
                        onClick={() => setEditModal(true)}
                    />
                </div>,
            ],
        },

    ];

    return (
        <div className={styles.mainCont}>
            <HeaderComponent
                heading={"Waste Log"}
                onSearch={(e) => console.log(e.target.value)}
                onSubmit={() => setaddModal(true)}
                submitButtonText={"Add Waste Entry"}
                showSubmitButton={true}
                showSearch={true}
                headingStyle={styles.headingStyle}
                showFilterIcon={true}
                onClickFilter={() => setFilterModal(true)}
            />

            {/* Table Section */}
            <div className={styles.subCont}>
                <div className={styles.TableDiv}>
                    <Table
                        scroll={{ x: true }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        rowKey="No"
                    />
                </div>
            </div>

            {/* /////////confirm modal ///////////////////// */}

            <Modal
                open={isModal}
                onCancel={() => { setIsModal(false) }}
                onClickOkButton={() => {
                    setIsModal(false);
                }}
                className={styles.modalCont}
                title={"Enter Supervisor Password"}
                headingClass={styles.modalHeading}
                width={"400px"}
                // btnStyle={{ width: "200px", }}
                twoButton
                okBtnTitle={"Confirm"}
                cancelBtnTitle={"Cancel"}
                onClickCancelButton={() => navigate("/")}

            // onBtnPress={() => setLimitExceedsModal(false)}
            >
                <InputField
                    placeholder={"12*******"}
                    innerInput={{ width: "" }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />


            </Modal>

            <ModalLeft
                open={addModal || editModal}
                onCancel={() => {
                    setaddModal(false)
                    setEditModal(false)
                }}
                className={styles.modalCont}
                // title={"Add Waste Entry"}
                title={editModal ? "Edit Waste Entry" : "Add Waste Entry"}
                buttonTitle={"save"}
                onBtnPress={() => {
                    setaddModal(false);
                    setEditModal(false);

                }}
                btnStyle={{ marginTop: '20px', width: '50%' }}
            >
                <div className={styles.modalContent}>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Task ID"} />
                        <div className={styles.search_div}>
                            <SearchInput
                                placeholder="#001"
                                rightIcon={<SearchOutlined />}
                                className={styles.searchInput}
                                value={taskId}
                                onChange={(e) => setTaskId(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Item Category"} />
                        <div className={styles.search_div}>
                            <Dropdown
                                value={category}
                                inputStyle={{
                                    backgroundColor: "var(--bg-grey)",
                                }}
                                options={categories}
                                onChange={(e) => setcategory(e)}
                            />
                        </div>
                    </div>

                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Item Name"} />
                        <div className={styles.search_div}>
                            <SearchInput
                                placeholder="Chocolate Muffin"
                                rightIcon={<SearchOutlined />}
                                className={styles.searchInput}
                                value={itemName}
                                onChange={(e) => setItemName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Quantity "} />
                        <div className={styles.itemControls}>
                            <MinusIcon className={styles.Controls} onClick={() => { quantity >= 1 && setquantity(quantity - 1) }} />
                            <TextComponent className={styles.ControlsText} text={quantity} />
                            <PlusIcon className={styles.Controls} onClick={() => setquantity(quantity + 1)} />
                        </div>
                    </div>

                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Lot No"} />
                        <div className={styles.search_div}>
                            <SearchInput
                                placeholder="#123"
                                rightIcon={<SearchOutlined />}
                                className={styles.searchInput}
                                value={lotNo}
                                onChange={(e) => setLotNo(e.target.value)}
                            // type={"number"}
                            />
                        </div>
                    </div>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Reason for Waste"} />
                        <div className={styles.search_div}>
                            <Dropdown
                                value={reason}
                                inputStyle={{
                                    backgroundColor: "var(--bg-grey)",
                                }}
                                options={reasons}
                                onChange={(e) => setreason(e)}
                            />
                        </div>
                    </div>
                </div>
            </ModalLeft>


            <Modal
                open={deleteModal}
                onClickOkButton={() => {
                    setDeleteModal(false);
                }}
                onCancel={() => setDeleteModal(false)}
                onClickCancelButton={() => setDeleteModal(false)}

                className={styles.modalCont}
                title={"Delete Waste Log?"}
                headingClass={styles.modalHeading}
                width={"400px"}
                twoButton
                okBtnTitle={"Confirm"}
                cancelBtnTitle={"Cancel"}
                btnStyle={{ width: "200px", marginTop: "12px" }}
                onBtnPress={() => setDeleteModal(false)}
            >
                <div>
                    <TextComponent
                        text="this action cannot be undone"
                        className={styles.CardText}
                    />
                </div>
            </Modal>

            {/* //////////////////// Filters ////////////////////// */}
            <Modal
                open={filterModal}
                onCancel={() => {
                    setFilterModal(false);
                }}
                className={styles.modalCont}
                title={"Filters"}
                headingClass={styles.modalHeading}
                width={"400px"}
                // btnStyle={{ width: "200px", }}
                twoButton
                okBtnTitle={"Apply Filters(1)"}
                cancelBtnTitle={"Reset All"}
                onClickCancelButton={() => setFilterModal(false)}
                onClickOkButton={() => {
                    setFilterModal(false)
                }}

            >
                <Dropdown
                    // label={"Category"}
                    // labelClass={styles.DropDownLabel}
                    value={reasonFilter}
                    inputStyle={{
                        backgroundColor: "#F7F8F9",
                        border: "1.5px solid #E8ECF4",
                    }}
                    inputClass={styles.DropdownInput}
                    style={{ color: "var(--black-color)" }}
                    options={reasonOpt}
                    onChange={(e) => setReasonFilter(e)}
                />
            </Modal>
        </div>
    );
};

export default WasteLog;
